import { ContentPagePanelType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IPagePanel, PagePanel } from "../common/pagePanel";

export class EventPagePanel extends PagePanel implements IPagePanel {
    getTitle(): string {
        switch (this.panelType) {
        case ContentPagePanelType.Statistics:
            return Translations.Events;
        case ContentPagePanelType.MyFiltersAndReports:
            return Translations.MyFiltersAndReports;
        case ContentPagePanelType.SharedFiltersAndReports:
            return Translations.SharedFiltersAndReports;
        case ContentPagePanelType.StandardFiltersAndReports:
            return Translations.StandardFiltersAndReports;
        default:
            return "";
        }
    }
}